import React from "react";
import { Heart } from "lucide-react";
import { cn } from "@/lib/utils";

type StatusProps = {
  status?: "approved" | "pending" | "rejected" | string;
  label?: string;
  show?: boolean;
  className?: string;
};

export function CardStatusTag({ status, label, show = true, className }: StatusProps) {
  if (!show) return null;
  const norm = String(status || '').toLowerCase().trim();

  const defaultLabel =
    norm === "approved"
      ? "Đã duyệt"
      : norm === "rejected"
      ? "Từ chối"
      : norm === "hot"
      ? "HOT"
      : "Chờ duyệt";

  const finalLabel = label ?? defaultLabel;
  if (!finalLabel) return null;

  return (
    <span
      className={cn(
        "px-3 py-0.5 rounded-full text-[11px] font-bold text-white shadow-sm w-max",
        norm === "approved"
          ? "bg-[#22c55e]" // Green
          : norm === "rejected"
          ? "bg-red-500" // Red
          : norm === "hot"
          ? "bg-red-600"
          : "bg-[#f59e0b]", // Amber
        className
      )}
    >
      {finalLabel}
    </span>
  );
}

type SaveBtnProps = {
  saved: boolean;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
};

export function CardSaveButton({ saved, onClick, className }: SaveBtnProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "w-8 h-8 rounded-full border transition-all flex items-center justify-center shrink-0 z-10 pointer-events-auto",
        saved 
          ? "bg-[#fff2eb] border-[#fdba74]" 
          : "bg-white border-[#fdba74] hover:bg-[#fff2eb]",
        className
      )}
      title={saved ? "Bỏ lưu" : "Lưu"}
    >
      <Heart 
        size={16} 
        className={cn(
          "stroke-[2.5px] transition-colors", 
          saved ? "fill-[#ea580c] stroke-[#ea580c]" : "stroke-[#ea580c]"
        )} 
      />
    </button>
  );
}
